import axios from 'axios';
import { getClinicAccessToken, clearClinicSession, isTokenExpired } from '../../Utils/clinicAuth';
import { sessionStore } from '../../Store/sessionStore';

const api = axios.create({
    headers: {
        "Content-Type": "application/json",
        hosts: window.location.origin,
    },
});

api.interceptors.request.use(
    (config) => {
        if (isTokenExpired()) {
            clearClinicSession();
            sessionStore.triggerExpiry();
            return Promise.reject(new Error('Token expired'));
        }
        const token = getClinicAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearClinicSession();
            sessionStore.triggerExpiry();
        }
        if (error.response?.status === 402) {
            // window.location.href = error.response?.data?.redirect || '/pricing';
        }
        return Promise.reject(error);
    }
);

export default api;
